import { FC, useState } from 'react'
import { IImportForm } from '../../model/IImportForm'
import ImportForm from '../components/import/ImportForm'
import useImport from '../hooks/useImport'
import Page from '../layout/Main/Page'
import { IHookApiError } from '../../model/IHookApi'
import toast from 'react-hot-toast'
import { IAddImportProductsResponse } from '../services/import.api'
import { useNavigate } from 'react-router-dom'

const NewImportPage: FC = () => {
  const { addImportProducts } = useImport()
  const navigate = useNavigate()

  const [stateErr, setStateErr] = useState<Partial<Record<keyof IImportForm, string>>>({})
  const [error, setError] = useState<string>()
  const [loading, setLoading] = useState<boolean>(false)

  const addSubmit = async (form: IImportForm) => {
    setStateErr(() => ({}))
    setError(() => undefined)

    setLoading(() => true)
    const response = await addImportProducts(form)
    setLoading(() => false)

    // -- Check errors
    const generalError = (response as IHookApiError)?.error
    if (generalError || (response as IAddImportProductsResponse).count === undefined) {
      toast.error(`Error occured: ${generalError}`)
      return setError(() => `Error occured: ${generalError}`)
    }

    toast.success(`${(response as IAddImportProductsResponse).count} Products joined the import tasks queue`)
    navigate('/imports')
  }

  return (
    <Page
      header={{
        title: `New Import`,
        subTitle: 'Add new products import task',
      }}
    >
      <ImportForm stateErrs={stateErr} onSubmit={addSubmit} />
    </Page>
  )
}

export default NewImportPage
